module.exports = __webpack_public_path__ + "static/img/class_17.5343c1bf.jpg";